$shm_echarts_settings $mol_view
	animation_duration_initial? 300
	animation_duration_update? 300
	animation_easing? \cubicInOut
	animation_duration_initial_save? null
	animation_duration_update_save? null
	sub /
		<= Animation_duration_initial_label $mol_labeler
			title \Начальная анимация (мс)
			Content <= Animation_duration_initial $mol_number
				value_min 0
				precision_change 50
				value? <=> animation_duration_initial?
				event *
					^
					focusout? <=> animation_duration_initial_save? null
		<= Animation_duration_update_label $mol_labeler
			title \Анимация обновления (мс)
			Content <= Animation_duration_update $mol_number
				value_min 0
				precision_change 50
				value? <=> animation_duration_update?
				event *
					^
					focusout? <=> animation_duration_update_save? null
		<= Animation_easing_label $mol_labeler
			title \Тип сглаживания анимации
			Content <= Animation_easing $mol_select
				value? <=> animation_easing? \cubicInOut
				dictionary <= animation_easing_options *
					cubicInOut \Плавное начало и завершение
					cubicOut \Плавное завершение
					cubicIn \Плавное начало
					linear \Линейное
